import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useState } from "react";

export function AuthenticateHeader() {
  const [orgId, setOrgId] = useState(localStorage.getItem("orgId"));

  const [formData, setFormData] = useState({
    orgId: "",
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    localStorage.setItem("orgId", formData.orgId);
    setOrgId(formData.orgId);
    window.location.reload();
  };

  const logout = () => {
    localStorage.removeItem("orgId");
    setOrgId("");
    window.location.reload();
  };
  return (
    <div className="flex items-center justify-between bg-white p-4 rounded-lg border-b">
      <h1 className="text-2xl font-bold">MedCase</h1>
      <div>
        {orgId ? (
          <>
            <Badge variant="outline" className="mr-2">
              {orgId}
            </Badge>
            <Button onClick={logout} variant="destructive" >Logout</Button>
          </>
        ) : (
          <Dialog>
            <DialogTrigger asChild>
              <Button>Authenticate</Button>
            </DialogTrigger>

            <DialogContent className="sm:max-w-md">
              <DialogHeader>
                <DialogTitle>Authenticate</DialogTitle>
                <DialogDescription>
                  Enter your org Id to continue.
                </DialogDescription>
              </DialogHeader>

              <form onSubmit={handleSubmit} className="space-y-4 mt-2">
                <div className="flex flex-col space-y-2">
                  <Label htmlFor="orgId">Org ID</Label>
                  <Input
                    id="orgId"
                    placeholder="Enter your orgId"
                    value={formData.orgId}
                    onChange={(e) =>
                      setFormData({ ...formData, orgId: e.target.value })
                    }
                    required
                  />
                </div>

                <div className="flex justify-end pt-2">
                  <Button type="submit">Authenticate</Button>
                </div>
              </form>
            </DialogContent>
          </Dialog>
        )}
      </div>
    </div>
  );
}
